/**
 * Which request replaced which, for this browsing session only.
 *
 * Rejecting a draft creates a brand-new request and the user is sent straight to
 * it. Coming back to the rejected one — browser back, an old link — there is no
 * way to name its replacement: v1 has no lineage-walk endpoint. So the id is
 * remembered in memory when we are the ones who caused the rejection, and the
 * rejected panel offers a link only then. Nothing is persisted, and a reload
 * simply loses the link rather than showing a stale one.
 */

const replacements = new Map<string, string>();

/** Records that `replacementId` is the regeneration of `rejectedId`. */
export function rememberReplacement(rejectedId: string, replacementId: string): void {
  replacements.set(rejectedId, replacementId);
}

/** The replacement request id, or null when this session did not see the reject. */
export function replacementFor(rejectedId: string): string | null {
  return replacements.get(rejectedId) ?? null;
}
